import { axiosApi } from '@/config/http';
import { getCountryAlpha3FromTld } from '@/helpers/getLastTld';
import type { ApiResponse } from '@/config/http/types';
import type { CountryFeatureFlag, FeatureFlagsResponse } from './types';

export default class FeatureFlagsService {
  static async getPartnerFlags(
    partnerUserId: string,
  ): Promise<FeatureFlagsResponse> {
    const countryCode = getCountryAlpha3FromTld();
    const response = await axiosApi.get<ApiResponse<FeatureFlagsResponse>>(
      '/v1/features/partner',
      { params: { country_code: countryCode, user_id: partnerUserId } },
    );
    return response.data.response;
  }

  static async getCountryFlags(): Promise<FeatureFlagsResponse> {
    const countryCode = getCountryAlpha3FromTld();
    const response = await axiosApi.get<ApiResponse<CountryFeatureFlag[]>>(
      `/v1/features/countries/${countryCode}`,
    );
    return response.data.response.reduce<FeatureFlagsResponse>((acc, flag) => {
      acc[flag.feature.slug] = flag.enabled;
      return acc;
    }, {});
  }
}
